import { prefix } from "../../design-tokens/meta";

export const componentClasses = Object.freeze({
    base: `${prefix}icon`,
});
